import { render, staticRenderFns } from "./cModalViewCarritoAct.vue?vue&type=template&id=0edf4e10&scoped=true"
import script from "./cModalViewCarritoAct.vue?vue&type=script&lang=js"
export * from "./cModalViewCarritoAct.vue?vue&type=script&lang=js"
import style0 from "./cModalViewCarritoAct.vue?vue&type=style&index=0&id=0edf4e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edf4e10",
  null
  
)

export default component.exports